import React, {useEffect, useState, useContext} from "react";
import {
    useNavigate,
    useParams,
    useSearchParams
} from "react-router-dom";
import {fetchJson} from "../fetch.js";
import * as BookPageHelpers from './helpers.js';
import LoadingSpinner from '../components/loadingSpinner.mjs';
import BookInfo from './BookInfo.js';
import { DataContext } from "./DataContext.js";
import {isInternal, isEntitled, decodeHTML} from "../helpers.mjs";
import { SearchContext } from "../components/SearchContext.js";

const ViewBookPage = ({results, extraData, bicCodes, themaCodes, bindings, broadbindings, keywords, languages, total, nextResult, setViewPrevious}) => {
    const { searchString, doSearchStringSearch } = useContext(SearchContext);
    let { isbn } = useParams();
    const [ searchParams, setSearchParams ] = useSearchParams();

    if(!results.hits.hits) {
        window.location.replace("/404");
        return (
            <div id="bookPageContainer" style={{ position: "relative" }}>
                <LoadingSpinner overlay={true} />
            </div>
        )
    }

    const elasticData = results.hits.hits.find(r => r._id == isbn)?._source;
    const elasticIndex = results.hits.hits.find(r => r._id == isbn)?._index;

    const search = searchParams.get("search");

    useEffect(() => {
        if (search && search != decodeURIComponent(searchString) && search != searchString && searchString != "") {
            doSearchStringSearch(search);
        }
    }, [search]);

    if (!elasticData) {
        return (
            <div id="bookPageContainer" style={{ position: "relative" }}>
                <LoadingSpinner overlay={true} />
            </div>
        )
    }

    return <div id="bookPageContainer" style={{ position: "relative" }}>
        <ResultsToolbar results={results} isbn={isbn} total={total} nextResult={nextResult} setViewPrevious={setViewPrevious} />
        <BookPage elasticData={elasticData} elasticIndex={elasticIndex} isbn={isbn} extraData={extraData} bicCodes={bicCodes} themaCodes={themaCodes} bindings={bindings} broadbindings={broadbindings} keywords={keywords} languages={languages} />
    </div>
}

const ResultsToolbar = ({ nextResult, setViewPrevious, results, total, isbn }) => {
    const { offset, page, wishlist, setViewingResult, changePage, searchString, goToResult } = useContext(SearchContext);
    const navigate = useNavigate();
    const [ searchParams, setSearchParams ] = useSearchParams();

    const index = results.hits.hits.findIndex(h => h._source.id == isbn);

    const back = (e) => {
        e.preventDefault();
        document.title = "Search results - Peters";

        if (searchParams.get("at")) {
            navigate(`/awards-timeline`);
        } else if (wishlist) {
            navigate(`/wishlist/view`);
        } else {
            navigate(`/search-results/${searchString}`);
        }
    }

    return <div className="toolbar">
        <div className="backToResults" onClick={back}><a href="#"><i className='far fa-chevron-double-left'></i> Back to current search</a></div>
        <div className="items">
            <div id="pageNav">
                {!(index == 0 && page == 1) && <button title='Previous result' type="button" className='actionButton adminColour far fa-chevron-left productNav navBack' onClick={() => {
                    setViewPrevious(true);
                    if (index == 0) {
                        changePage(page - 1);
                    } else {
                        goToResult(results.hits.hits[index - 1]._source.id);
                    }
                }}></button>}
                {index !== null && total !== null && results.hits !== null && <div className='itemNumberText'>Result {(offset + index + 1).toLocaleString()} of {total.toLocaleString()}</div>}
                {((offset + index + 1) != total) && <button title='Next result' type="button" className='actionButton adminColour far fa-chevron-right productNav navNext' onClick={() => { nextResult() }}></button>}
            </div>
        </div>
    </div>
}

const BookPage = ({elasticData, elasticIndex, isbn, extraData, bicCodes, themaCodes, bindings, broadbindings, keywords, languages}) => {
    const { baskets, setViewingResult } = useContext(SearchContext);

    const product = elasticData?.product_id;
    const [productData, setProductData] = useState(false);
    const [ukslcCodes, setUkslcCodes] = useState([]);
    const [orderingData, setOrderingData] = useState([]);
    const [ratingsData, setRatingsData] = useState([]);
    const [ksGroupsData, setKsGroupsData] = useState([]);
    const [altEditions, setAltEditions] = useState([]);
    const [keywordsData, setKeywordsData] = useState([]);
    const [productResources, setProductResources] = useState([]);
    const [distributorInfo, setDistributorInfo] = useState([]);
    const [bookMatchRatings, setBookMatchRatings] = useState([]);
    const [keyStageInfo, setKeyStageInfo] = useState([]);
    const bookBands = BookPageHelpers.getBookBands();
    
    // Book page html
    useEffect(() => {
        if(elasticData.meta_title) {
            document.title = decodeHTML(`${elasticData.meta_title}`);
        } else if (elasticData.authors && elasticData.authors?.length > 0) {
            // TEMP primary_author_nat FIX HOPEFULLY 
            const primaryAuthorNames = (elasticData.primary_author ? elasticData.primary_author.title.split(",") : []);
            const primaryAuthorFirstName = primaryAuthorNames.pop()
            const primaryAuthorNameNat = primaryAuthorFirstName.trim() + " " + primaryAuthorNames.join(", ").trim();
            document.title = decodeHTML(`${elasticData.title} by ${primaryAuthorNameNat} (${elasticData.id})`);
        } else {
            document.title = decodeHTML(`${elasticData.title} (${elasticData.id})`);
        }

        if ($('.embeddedSearchPage').length > 0) {
            var anchor = $('#quickSearch');

            $('html,body').animate({
                scrollTop: anchor.offset().top
            }, 500);
        }
        // else {
        //     $(window).scrollTop(0);
        // }

        setViewingResult(isbn);

        // Load product data
        fetchJson(`/product/productPageData/${isbn}`).then((response) => {
            setProductData(response);
            setRatingsData(response.ratingsData);
            setBookMatchRatings(response.bookMatchRatings);
        });
        
        fetchJson("/assets/json/allUkslc.json").then(r => {          
            setUkslcCodes(r);
        });

        if(elasticData?.productcategorylinks?.length > 0) {
            fetchJson(`/product/keyStageGroupsInfo/${elasticData.productcategorylinks}`).then(r => {          
                setKsGroupsData(r);
            });
        } else {
            fetchJson(`/product/allKeyStageGroups/${product}`).then(r => {          
                setKsGroupsData(r);
            });
        }

        fetchJson(`/product/allAltEditions/${product}`).then(r => {          
            setAltEditions(r)
        });

        fetchJson(`/product/getProductResources/${product}`).then(r => {          
            setProductResources(r);
        });

        if (isInternal) {
            fetchJson(`/product/getDistributorInfo/${isbn}`).then(r => {          
                setDistributorInfo(r);
            });
        }

        fetchJson(`/product/getKeyStageInfo/${product}`).then(r => {          
            setKeyStageInfo(r);
        });
    }, [isbn]);

    useEffect(() => {
        if (!isEntitled()) {
            return;
        }

        fetchJson(`/product/orderingData/${product}`).then(r => {
            setOrderingData(r);
        });
    }, [baskets, isbn]);

    const _source = elasticData;

    const _title = _source && `${_source.title ?? ``}  ${_source.authors ? `by ${_source.authors.map(a => a.title).join(", ")}` : ``} (${isbn}) - Peters`

    return (
        <DataContext.Provider value={{
            elasticData,
            elasticIndex,
            productData,
            bindings,
            broadbindings,
            bookBands,
            isbn,
            product,
            themaCodes,
            keywords,
            ukslcCodes,
            bicCodes,
            orderingData,
            ratingsData,
            ksGroupsData,
            altEditions,
            keywordsData,
            productResources,
            distributorInfo, 
            bookMatchRatings,
            keyStageInfo,
            languages
        }}>
            <div className="bookpage productContainer" data-ean13={isbn} data-id={product} data-title={decodeHTML(_title)}>
                {elasticData && <BookInfo extraData={extraData ? extraData[product] : null} />}
                <div id="noDownloadPopup" d className="popup">
                    <div style={{width:"480px",height:"140px"}} className="popupSection">
                        <h3 className="popupTitle">Please log in to download this resource</h3>
                        <div className="buttons">
                            <a className="login button newEditor popupConfirm">Log in</a>
                            <span className="button newEditor popupCancel">Cancel</span>
                        </div>
                    </div>
                </div>
            </div>
        </DataContext.Provider>
    );
}

export default ViewBookPage;